/**
 * Category listing population, from Optimizely. `query` populates every category page from its
 * content query. Anything else, including no assignment, leaves it to the page's own `use_query`
 * setting, which otherwise populates by category id.
 */
export enum ClpPopulation {
  NAME = 'clp_population',
  QUERY = 'query',
}

/**
 * Sponsored products on listing pages, from Optimizely. `on` shows them; anything else,
 * including no assignment, is the organic listing.
 */
export enum SponsoredListingsProducts {
  NAME = 'sponsored_listings_products',
  ON = 'on',
}
